/* Google's official callback supplies the number; this only keeps owned
   phone displays in sync when React mounts routes, menus or error messages. */
const BUSINESS_NUMBER = process.env.REACT_APP_BUSINESS_PHONE_DISPLAY;
const normalize = (value) => String(value || '').replace(/\D/g, '');
const businessDigits = normalize(BUSINESS_NUMBER);
const national = businessDigits.slice(-10);
const businessPattern = new RegExp(
  `(^|[^\\d])(?:\\+?1[\\s().-]*)?\\(?${national.slice(0, 3)}\\)?[\\s.-]*${national.slice(3, 6)}[\\s.-]*${national.slice(6)}(?!\\d)`, 'g'
);

export const startGooglePhoneSync = () => {
  if (typeof window === 'undefined' || window.__PRERENDER__) return () => {};
  if (!BUSINESS_NUMBER || businessDigits.length !== 11) {
    throw new Error('REACT_APP_BUSINESS_PHONE_DISPLAY must contain the full business number');
  }
  let frame = null;
  let stopped = false;
  const assignedDisplays = new Set();

  const sync = () => {
    frame = null;
    if (stopped || window.location.pathname.startsWith('/admin')) return;
    const value = window.__ssfGoogleForwarding;
    const mobile = normalize(value?.mobile);
    if (!value?.formatted || !/^[\d\s()+.-]+$/.test(value.formatted) || !/^\d{10,15}$/.test(mobile)) return;
    const display = value.formatted;
    const tel = `tel:+${mobile.length === 10 ? '1' : ''}${mobile}`;
    const replace = (text) => {
      let result = text.replace(businessPattern, (_, prefix) => prefix + display);
      assignedDisplays.forEach((previous) => {
        if (previous !== display) result = result.split(previous).join(display);
      });
      return result;
    };

    document.querySelectorAll('[data-business-phone]').forEach((element) => {
      if (element.closest('script, style, noscript, input, textarea, select, [contenteditable], a[href^="sms:"]')) return;
      if (element.matches('a[href^="tel:"]') && element.getAttribute('href') !== tel) {
        element.setAttribute('href', tel);
      }
      const aria = element.getAttribute('aria-label');
      if (aria && replace(aria) !== aria) element.setAttribute('aria-label', replace(aria));
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script, style, noscript, input, textarea, select, [contenteditable], a[href^="sms:"]')) continue;
        const text = replace(node.nodeValue);
        if (text !== node.nodeValue) node.nodeValue = text;
      }
    });
    assignedDisplays.add(display);
  };
  const schedule = () => {
    if (!stopped && frame === null) frame = window.requestAnimationFrame(sync);
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
  window.addEventListener('ssf-google-phone-number', schedule);
  schedule();
  return () => {
    stopped = true;
    observer.disconnect();
    window.removeEventListener('ssf-google-phone-number', schedule);
    if (frame !== null) window.cancelAnimationFrame(frame);
  };
};